import dayjs from "dayjs";

import { createSellarColumnHelper } from "@sellar-io/components";

import type {
  InvoicePayoutType,
  CreditNotePayoutType,
  InvoiceNextPayoutType,
} from "@sellar-io/api-v2/types";

import { type DocumentType } from "../stores/PayoutFilterStore";

import {
  BadgeGreen,
  BadgeWhiteFill,
  BadgeRed,
  BadgeZinc,
} from "~/components/badge/Badge";

export type BaseTableRow = {
  id: number | null;
  customId: string;
  date: string | Date;
  customer: string;
  total: number;
};

export type TableRow =
  | (BaseTableRow & {
      type: "invoice" | "fee";
      order: { id: number };
    })
  | (BaseTableRow & {
      type: "credit-note";
      order?: undefined;
    });

export type SellarCreditDocument = {
  type: DocumentType;
  contents: InvoicePayoutType | CreditNotePayoutType | InvoiceNextPayoutType;
};

export const columnHelper = createSellarColumnHelper<TableRow>();

export const getEmptyMessage = (
  search: string,
  documentType: DocumentType | "all",
) => {
  if (search || documentType !== "all") return "Your search returned 0 results";
  return "No payouts currently available";
};

export function getBadgeColor(
  status:
    | "optimistic"
    | "draft"
    | "paid"
    | "failed"
    | "issued"
    | "payment_processing",
  payoutDate: Date | null,
) {
  switch (status) {
    case "optimistic":
      return <></>;
    case "draft":
      return (
        <BadgeWhiteFill className="text-sm font-medium">Draft</BadgeWhiteFill>
      );
    case "payment_processing":
      return (
        <BadgeZinc className="text-sm font-medium">
          Payment&nbsp;processing
        </BadgeZinc>
      );
    case "paid":
      return (
        <BadgeGreen className="text-sm font-medium">
          Paid&nbsp;{dayjs(payoutDate).format("DD/MM/YYYY")}
        </BadgeGreen>
      );
    case "failed":
      return <BadgeRed className="text-sm font-medium">Failed</BadgeRed>;
    default:
      return status;
  }
}
